/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-26 12:08 pm
 * Last Modified: Thursday, 25-03-06 11:11 am, by Ben Zhao
 */

import { i18n } from 'next-i18next';

import { toFixedCeil } from '@web/utils';

import type {
  EnhancedCardFee,
  PhysicalCardStatus,
  VirtualCardStatus,
} from '@/@types/card';

const option = { ns: 'card' };

export const getPhysicalCardStatus = (status?: PhysicalCardStatus) => {
  if (!status) {
    return;
  }

  return i18n?.t(`main.physical-card-status.${status}`, option);
};

export const getVirtualCardStatus = (status: VirtualCardStatus) => {
  return i18n?.t(`main.normal-card-status.${status}`, option);
};

export const getApplyFee = (
  type: string,
  cardFees: EnhancedCardFee,
  options?: {
    isFirstApply?: boolean;
    isSelf?: boolean;
  },
): Omit<EnhancedCardFee, 'cardType'> => {
  // todo xxxx
  if (type === 'VIP') {
    return {
      applyFee: options?.isFirstApply
        ? '0'
        : toFixedCeil(
            options?.isSelf
              ? Number(cardFees.makingFee)
              : Number(cardFees.makingFee) + Number(cardFees.postalFee),
          ),
      minBalance: cardFees.minBalance,
      makingFee: options?.isFirstApply ? '0' : cardFees.makingFee,
      annualFee: cardFees.annualFee,
      postalFee:
        options?.isFirstApply || options?.isSelf ? '0' : cardFees.postalFee,
      frozenFee: cardFees.frozenFee,
      unit: cardFees.unit,
      currency: cardFees.unit,
    };
  }

  return {
    applyFee: toFixedCeil(
      options?.isSelf
        ? Number(cardFees.makingFee)
        : Number(cardFees.makingFee) + Number(cardFees.postalFee),
    ),
    minBalance: cardFees.minBalance,
    makingFee: cardFees.makingFee,
    annualFee: cardFees.annualFee,
    postalFee: options?.isSelf ? '0' : cardFees.postalFee,
    frozenFee: cardFees.frozenFee,
    unit: cardFees.unit,
    currency: cardFees.unit,
  };
};

export const formatCardNumber = (cardNumber: string) => {
  return cardNumber.replace(/(?:.{4})/g, '$& ');
};
